import { render } from "./App.vue?vue&type=template&id=b063b044"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=b063b044&lang=scss"

import exportComponent from "F:\\freelance\\web development\\project twelve\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__